import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

function SvgComponent(props) {
    return (
        <Svg width={308} height={30} viewBox="0 0 308 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M294.764 30C290.099 30 285.155 28.4441 282.883 26.25L282.683 17.3138C285.315 20.5452 290.099 22.859 294.485 22.859C297.196 22.859 298.99 22.0213 298.99 20.6649C298.99 18.8697 295.441 18.4309 291.494 17.3138C285.913 15.8378 282.404 13.125 282.404 8.81649C282.404 3.59042 288.026 0 295.242 0C299.667 0 304.212 1.39627 306.485 2.87234L307.043 11.25C303.535 8.53723 299.229 7.06117 295.282 7.06117C292.81 7.06117 291.056 7.73936 291.056 8.89627C291.056 10.4122 293.528 10.6915 298.272 12.008C304.093 13.4441 308 15.9176 308 20.5851C308 26.1303 302.099 30 294.764 30Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M247.933 29.4814V0.518586H255.03L269.94 16.8351V0.518586H278.472V29.4814H271.216L256.545 13.2446V29.4814H247.933Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M226.601 30C216.235 30 208.541 23.7367 208.541 15C208.541 6.2633 216.235 0 226.601 0C236.967 0 244.662 6.2633 244.662 15C244.662 23.7367 236.967 30 226.601 30ZM226.601 22.4202C231.585 22.4202 235.133 19.508 235.133 15C235.133 10.492 231.585 7.57979 226.601 7.57979C221.617 7.57979 218.069 10.492 218.069 15C218.069 19.508 221.617 22.4202 226.601 22.4202Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M196.349 29.4814V0.518586H205.2V29.4814H196.349Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M175.08 29.4814V7.8989H165.512V0.518586H193.3V7.8989H183.811V29.4814H175.08Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M152.584 30C142.737 30 134.643 23.9761 134.643 15.1596C134.643 6.8617 141.86 0 152.903 0C156.252 0 159.96 0.718084 163.03 2.43351L163.269 11.5293C160.399 8.93617 157.01 7.4601 153.422 7.4601C148.558 7.4601 144.172 10.3324 144.172 14.9601C144.172 19.6277 148.438 22.5399 153.501 22.5399C157.012 22.5399 160.018 21.0055 163.189 18.4923L162.561 29.0789C160.679 29.8855 156.055 30 152.584 30Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M122.452 29.4814V0.518586H131.303V29.4814H122.452Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M88.4196 29.4814V0.518586H101.736C111.822 0.518586 119.118 6.02391 119.118 14.8803C119.118 23.8962 111.703 29.4814 101.855 29.4814H88.4196ZM100.46 22.2606C105.762 22.2606 109.59 20.3856 109.59 15C109.59 9.69412 106.081 7.73933 100.42 7.73933H97.1508V22.2606H100.46Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M61.3214 29.4814V0.518586H85.2425V7.65954H69.8931V11.7287H81.2557V17.992H69.8931V22.2606H85.2425V29.4814H61.3214Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M30.4076 29.4814V0.518586H44.6008C54.249 0.518586 57.598 5.26592 57.598 9.69412C57.598 13.7633 54.3686 17.3936 49.2655 18.7899L58.9137 29.4814H48.2687L39.8166 19.3484H39.1388V29.4814H30.4076ZM44.1224 13.0851C46.5544 13.0851 48.3884 11.9282 48.3884 10.1728C48.3884 8.29784 46.6341 7.22071 44.1224 7.22071H39.1388V13.0851H44.1224Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
            <Path
                d="M0 29.4814V0.518586H13.7148C24.0806 0.518586 27.7087 5.4255 27.7087 10.6915C27.7087 16.3165 23.363 21.1436 13.954 21.1436H8.73123V29.4814H0ZM13.1168 14.3218C16.1069 14.3218 18.3396 13.1649 18.3396 10.7712C18.3396 8.41752 16.2664 7.34039 13.1168 7.34039H8.73123V14.3218H13.1168Z"
                fill={props.color ?? ds.colorValue.icon.primary}
            />
        </Svg>
    );
}

export default SvgComponent;
